/*
 * @Description: 工程入口文件
 * @Author: Mars
 * @Date: 2023-11-30 14:28:00
 */
import './global.less';
import { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { bootApp } from '@/utils/boot';
import { initVideojsI18n } from '@/utils/videojs-i18n';

initVideojsI18n();

// 启动编排跑完（大区列表 → 国家与语言 → i18n）才挂载 React，原因见 utils/boot。
// App 要动态 import：store/country 的 countryInfo atom 在模块求值时就按本地缓存取初值，
// 静态 import 会让它在 bootApp 写回校正后的国家之前就固化成未校验的占位值。
bootApp().then(async () => {
  const { default: App } = await import('@/App');

  const Main = () => {
    // 等 React 提交完第一帧再摘掉 index.html 里的静态 loading，直接在 render 之后摘会闪一帧白
    useEffect(() => {
      document.getElementById('app-loading')?.remove();
    }, []);

    return <App />;
  };

  ReactDOM.createRoot(document.getElementById('root')!).render(<Main />);
});
